import { faTag, faUserPen } from '@awesome.me/kit-a6e51d954f/icons/classic/regular';

import { CreatorList, TagList } from './components/CalendarGrid/Header/FilterLists';
import Week from './components/CalendarGrid/Week';
import Month from './components/CalendarGrid/Month';

export const CALENDAR_VIEWS = {
  WEEK: {
    component: Week,
    label: 'Week',
    value: 'week',
  },
  MONTH: {
    component: Month,
    label: 'Month',
    value: 'month',
  },
};

export const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export const DEFAULT_APPOINTMENT_COLOR = 'gray';

export const DIALOG_TITLES = {
  appointment: {
    create: 'Add a new appointment',
    update: 'Edit appointment',
  },
};

export const ERROR_TITLES = {
  appointment: {
    create: 'Unable to create an appointment.',
    delete: 'Unable to delete the appointment.',
    update: 'Unable to update the appointment.',
  },
};

export const FILTERS = [
  {
    emptyMessage: 'No creators found.',
    icon: faUserPen,
    label: 'Creator',
    listComponent: CreatorList,
    searchPlaceholder: 'Search creators...',
    type: 'creators',
  },
  {
    emptyMessage: 'No tags found.',
    icon: faTag,
    label: 'Tag',
    listComponent: TagList,
    searchPlaceholder: 'Search tags...',
    type: 'tags',
  },
];

export const SUCCESS_MESSAGES = {
  appointment: {
    create: 'Appointment created.',
    delete: 'Appointment deleted.',
    update: 'Appointment updated.',
  },
};

export const TIMES = [
  '12:00 AM',
  '1:00 AM',
  '2:00 AM',
  '3:00 AM',
  '4:00 AM',
  '5:00 AM',
  '6:00 AM',
  '7:00 AM',
  '8:00 AM',
  '9:00 AM',
  '10:00 AM',
  '11:00 AM',
  '12:00 PM',
  '1:00 PM',
  '2:00 PM',
  '3:00 PM',
  '4:00 PM',
  '5:00 PM',
  '6:00 PM',
  '7:00 PM',
  '8:00 PM',
  '9:00 PM',
  '10:00 PM',
  '11:00 PM',
];
